import _taggedTemplateLiteral from "/workspace/bitx-bitxhub-website-cd/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _ = function _(t) {
  return t;
},
    _t;

import * as React from 'react';
import clsx from 'clsx';
import { unstable_extendSxProp as extendSxProp } from '@material-ui/system';
import styled from '../styles/experimentalStyled';
import { jsx as _jsx } from "react/jsx-runtime";
var BoxRoot = styled('div', {}, {
  muiName: 'MuiBox',
  skipVariantsResolver: true
})(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral([""])))));
/**
 * @ignore - do not document.
 */

var Box = /*#__PURE__*/React.forwardRef(function Box(inProps, ref) {
  var _extendSxProp = extendSxProp(inProps),
      className = _extendSxProp.className,
      _extendSxProp$compone = _extendSxProp.component,
      component = _extendSxProp$compone === void 0 ? 'div' : _extendSxProp$compone,
      other = _objectWithoutPropertiesLoose(_extendSxProp, ["className", "component"]);

  return /*#__PURE__*/_jsx(BoxRoot, _extends({
    as: component,
    ref: ref,
    className: clsx(className, 'MuiBox-root')
  }, other));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Box;